/* PWA desligado de propósito. Em vez de registar um service worker, removemos
   qualquer SW antigo desta origem e limpamos as caches, para o site nunca servir
   versões obsoletas (foi a causa do site preso em cache após a troca de domínio).
   O sw.js na raiz é um kill-switch que faz a limpeza do lado do worker. */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(function (rs) { rs.forEach(function (r) { r.unregister(); }); })
    .catch(function () {});
}
if (window.caches && caches.keys) {
  caches.keys().then(function (keys) {
    keys.forEach(function (k) { caches.delete(k); });
  }).catch(function () {});
}
